import React from "react";
import "./Cresta.scss";
import data from "./data.json";
import Card from "../../Component/Card/card";
import Cresta5images from "../../Media/KHI/Cresta/Cresta 5/Cresta5";
import Cresta7images from "../../Media/KHI/Cresta/Cresta 7/Cresta7";

const imageMap = {
  Cresta5images,
  Cresta7images,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="cresta" className="produk1">
      <div className="cardhome-containercalamus">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
